var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import RadioCheckboxCard from '@marketing/components/funnel/FormFields/RadioCheckboxCard';
import { useProfileContext } from '../ProfileContext';
var GENDERS = ['male', 'female'];
var PetGenderInput = function (_a) {
    var gender = _a.gender, handleGenderChange = _a.handleGenderChange, petName = _a.petName;
    var serverLoading = useProfileContext().serverLoading;
    return (_jsx("fieldset", __assign({ className: "group", disabled: serverLoading }, { children: _jsxs("div", __assign({ className: "w-full md:min-w-sm grid grid-cols-1 gap-6 md:gap-20" }, { children: [_jsxs("legend", __assign({ className: "text-center" }, { children: ["What is ", petName, "\u2019s gender?"] })), _jsx("div", __assign({ className: "w-full md:w-fit mx-auto grid grid-cols-1 md:grid-cols-2 justify-items-center gap-6" }, { children: GENDERS.map(function (row) {
                        var genderId = "gender-".concat(row);
                        return (_jsx("div", __assign({ className: "w-[240px] md:w-[323px] mx-auto" }, { children: _jsx(RadioCheckboxCard, __assign({ className: "p-4 md:p-6", checked: row === gender, name: "gender", onInputChange: handleGenderChange, optionId: genderId, type: "radio", value: row }, { children: _jsx("span", __assign({ className: "capitalize text-3xl-head-m md:text-3xl-head-d font-display" }, { children: row })) })) }), genderId));
                    }) }))] })) })));
};
export default PetGenderInput;
